import { useGetAllActivityItemsQuery } from "features/activity/activitySlice";
import { useGetInvoiceAccountsQuery, useGetInvoiceVendorsQuery } from "features/invoice/loads/loadInvoiceSlice";
import { useGetVendorsQuery } from "features/vendor/vendorSlice";

export const quickBooksMappingEntityTypes = {
    VENDOR: 1,
    ACTIVITY_ITEM: 2,
};

export const entityTypeConfigMap = {
  [quickBooksMappingEntityTypes.VENDOR]: {
    useEntityTypeQuery: useGetVendorsQuery,
    useQuickbooksQuery: useGetInvoiceVendorsQuery,
    entityKey: 'name',     
    quickbooksKey: 'displayName',
    entityTitle: 'Parq Vendor',
    quickbooksTitle: 'Quickbooks Vendor',
  },
  [quickBooksMappingEntityTypes.ACTIVITY_ITEM]: {
    useEntityTypeQuery: useGetAllActivityItemsQuery,
    useQuickbooksQuery: useGetInvoiceAccountsQuery,
    entityKey: 'name',
    quickbooksKey: 'fullyQualifiedName',
    entityTitle: 'Parq Activity',
    quickbooksTitle: 'Quickbooks Category',
  },
};